module.exports = __webpack_public_path__ + "media/images/emblems/Trelex-coat_of_arms-51150df52d79d846518de69265317b18.svg";